import { useState, useCallback } from 'react';

export interface RecentItem {
  type: string;
  id: string;
  label: string;
  subtitle?: string;
  timestamp: number;
}

const STORAGE_KEY = 'topshots_recent_items';
const MAX_ITEMS = 10;

function loadRecents(): RecentItem[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function saveRecents(items: RecentItem[]) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function useRecentItems() {
  const [recents, setRecents] = useState<RecentItem[]>(loadRecents);

  const addRecent = useCallback(
    (item: Omit<RecentItem, 'timestamp'>) => {
      setRecents((prev) => {
        const filtered = prev.filter(
          (r) => !(r.type === item.type && r.id === item.id)
        );
        const next = [
          { ...item, timestamp: Date.now() },
          ...filtered,
        ].slice(0, MAX_ITEMS);
        saveRecents(next);
        return next;
      });
    },
    []
  );

  const clearRecents = useCallback(() => {
    setRecents([]);
    localStorage.removeItem(STORAGE_KEY);
  }, []);

  return { recents, addRecent, clearRecents };
}
